import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { DiscussionListComponent } from '@farris/discussion-group';
import { ComponentRef } from "./component-ref";

@Directive({
  selector: '[discussionListRef]'
})
export class DiscussionListComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: DiscussionListComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }

}